'use client';

import { Box } from '@mui/material';

import { CategoryChip, CategoryChipSkeleton } from '@/components';
import type { BreakingNewsCategory } from '@/types/breaking.types';

interface BreakingCategoriesProps {
  categories: BreakingNewsCategory[];
  selectedTagId: string | null;
  onCategoryClick: (tagId: string | null) => void;
  isLoading?: boolean;
}

export function BreakingCategories({
  categories,
  selectedTagId,
  onCategoryClick,
  isLoading = false,
}: BreakingCategoriesProps) {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          mb: 3,
          flexWrap: { xs: 'nowrap', sm: 'wrap' },
          overflowX: { xs: 'auto', sm: 'visible' },
          overflowY: 'hidden',
          pb: { xs: 1, sm: 0 },
          WebkitOverflowScrolling: 'touch',
          scrollBehavior: 'smooth',
          width: '100%',
          maxWidth: '100%',
        }}
      >
        <CategoryChipSkeleton />
      </Box>
    );
  }

  const renderCategory = (category: BreakingNewsCategory) => {
    const isSelected = selectedTagId === category.tagId;

    return (
      <CategoryChip
        key={category?.tagId ?? 'all'}
        label={category?.name || ''}
        isActive={isSelected}
        onClick={() => onCategoryClick(category?.tagId)}
      />
    );
  };

  const renderCategoriesList = categories?.map(renderCategory);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        mb: 3,
        flexWrap: { xs: 'nowrap', sm: 'wrap' },
        overflowX: { xs: 'auto', sm: 'visible' },
        overflowY: 'hidden',
        pb: { xs: 1, sm: 0 },
        WebkitOverflowScrolling: 'touch',
        scrollBehavior: 'smooth',
        width: '100%',
        maxWidth: '100%',
      }}
    >
      {renderCategoriesList}
    </Box>
  );
}
